import type { CommandBody } from "../CrossOriginMessage";

/**
 * Provides the available application languages.
 */
export class AvailableLanguagesCommandBody implements CommandBody {
  /**
   * Available languages.
   */
  languages: string[];
}
